import BreadcrumbSkeleton from "components/skeleton/breadcrumb-1";
import Breadcrumb from "components/shared/breadcrumb";
import { useEffect, useState, memo, useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { toMoneyFormat, unixToShamsi } from "utils";
import Modal from "components/shared/modal";
import { toast } from "react-toastify";
import MasterAPI from "service/master";
import TransactionsTypes from "constants/transaction-types";
import ServiceTypes from "constants/service-types";
import UseFetch from "hooks/useFetch";
import TransactionsStatus from "constants/transactions-status";

const Edit = props => {
    const {
        pageData,
        id,
        setServerBreadcrumbDataCallback,
        serverBreadcrumb
    } = props;

    const location = useLocation();
    const [fetchUrl, setFetchUrl] = useState();
    const { isLoading, data, error } = UseFetch(fetchUrl);
    const urlParams = new URLSearchParams(location.search);
    const [cancelLoading, setCancelLoading] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelReason, setCancelReason] = useState("");

    const getPreviousRoute = () => {
        const splitedRoute = location.pathname.split("/");
        splitedRoute.pop();

        let previousRoute = splitedRoute.join("/");
        const validParams = [];

        if (pageData && pageData.add_valid_params)
            pageData.add_valid_params.forEach(param => {
                const paramValue = urlParams.get(param);
                if (paramValue)
                    validParams.push(`${param}=${paramValue}`);
            })

        if (validParams.length)
            previousRoute += `?${validParams.join("&")}`;

        return previousRoute;
    }

    useEffect(() => {
        if (pageData)
            setFetchUrl(pageData.get_url.replace(":id", id));
        // eslint-disable-next-line
    }, [pageData])

    useEffect(() => {
        if (data && data.breadcrumbs?.length)
            setServerBreadcrumbDataCallback(data.breadcrumbs);
        else
            setServerBreadcrumbDataCallback([]);
        // eslint-disable-next-line
    }, [data])

    const serviceData = useMemo(() => {
        if (!isLoading && !error && data)
            return data.data;

        return {};
    }, [data, isLoading, error])

    const cancelHandler = async e => {
        e.preventDefault();

        if (cancelLoading)
            return;

        if (cancelReason.length === 0) {
            toast.error("لطفا دلیل لغو را بنویسید");
            return;
        }

        setCancelLoading(true);
        try {
            const res = await MasterAPI({
                url: "/api/financial/order/cancel",
                payloadType: 3,
                method: "PUT",
                data: {
                    id: serviceData.id,
                    cancel_description: cancelReason
                },
                callback: () => setCancelLoading(false)
            });

            setShowCancelModal(false);
            toast.success(res.message);
        } catch (e) {
            toast.error(e.message);
        }
    }

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">ویرایش</h1>

                    {
                        !isLoading ? (
                            serverBreadcrumb.length
                                ? <Breadcrumb data={serverBreadcrumb} />
                                : <Breadcrumb data={pageData.breadcrumb} />
                        ) : (
                            <BreadcrumbSkeleton />
                        )
                    }
                </div>

                <div className="flex">
                    <Link to={getPreviousRoute()} className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center">
                        <i className="fa-regular fa-arrow-right"></i>
                    </Link>
                </div>
            </div>

            <div className="wrap-box tp-22">
                {
                    !isLoading ? (
                        !error ? (
                            <>
                                <div className="bg-yellow-100 flex items-center mb-5 rounded-md p-3 dark:bg-slate-800">
                                    <i className="fa-regular fa-circle-exclamation text-sm text-green-600 dark:text-green-300 ml-3"></i>

                                    <p className="text-sm text-green-800 dark:text-slate-300">
                                        <b className="inline-block ml-2">وضعیت تراکنش</b>
                                        <span>{TransactionsStatus[serviceData.status_id]?.title || "---"}</span>
                                    </p>
                                </div>

                                {
                                    !!serviceData.meta_data?.title && (
                                        <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                            <ul className="order-detail">
                                                <li className="inline">
                                                    <span>عنوان</span>
                                                    <b>{serviceData.meta_data.title}</b>
                                                </li>
                                            </ul>
                                        </div>
                                    )
                                }

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>شناسه تراکنش</span>
                                            <b>{serviceData.id}</b>
                                        </li>

                                        <li className="inline">
                                            <span>نوع تراکنش</span>
                                            <b>{TransactionsTypes[serviceData.type_id]?.title || "---"}</b>
                                        </li>

                                        <li className="inline">
                                            <span>نوع سرویس</span>
                                            <b>{ServiceTypes[serviceData.service_type_id]?.title || "---"}</b>
                                        </li>
                                    </ul>
                                </div>

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>مبلغ تراکنش</span>
                                            <b>{toMoneyFormat(serviceData.final_price)} <span> تومان</span></b>

                                            {
                                                serviceData.payer_user_id === 0
                                                    ? <span className="rounded-md bg-green-500 text-xs py-1 px-2" style={{ color: "#fff" }}>واریزی</span>
                                                    : <span className="rounded-md bg-red-500 text-xs py-1 px-2" style={{ color: "#fff" }}>برداشتی</span>
                                            }
                                        </li>
                                    </ul>
                                </div>

                                {
                                    !!serviceData.order_oid && (
                                        <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                            <ul className="order-detail">
                                                <li className="inline-flex items-center">
                                                    <span>شناسه گروه سفارش</span>
                                                    <b><Link to={`/panel/order/${serviceData.order_oid}`}>#{serviceData.order_oid}</Link></b>
                                                </li>
                                            </ul>
                                        </div>
                                    )
                                }

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>تاریخ ایجاد تراکنش</span>
                                            <b>{serviceData.created_at ? unixToShamsi(serviceData.created_at) : "--"}</b>
                                        </li>

                                        <li className="inline">
                                            <span>تاریخ تایید تراکنش</span>
                                            <b>{serviceData.accounting_confirm_date ? unixToShamsi(serviceData.accounting_confirm_date) : "--"}</b>
                                        </li>
                                    </ul>
                                </div>

                                <div className="py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>تاریخ رزرو</span>
                                            <b>{serviceData.reserve_until ? unixToShamsi(serviceData.reserve_until) : "---"}</b>
                                        </li>

                                        <li className="inline-flex items-center">
                                            <span>رزرو</span>

                                            {
                                                serviceData.reserved
                                                    ? <i className="fa-solid fa-square-check text-green-500 text-base" title="رزرو شده"></i>
                                                    : <i className="fa-solid fa-rectangle-xmark text-red-500 text-base" title="رزرو نشده"></i>
                                            }
                                        </li>

                                        <li className="inline-flex items-center">
                                            <span>تراکنش دستی</span>

                                            {
                                                serviceData.manual
                                                    ? <i className="fa-solid fa-square-check text-green-500 text-base"></i>
                                                    : <i className="fa-solid fa-rectangle-xmark text-red-500 text-base"></i>
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </>
                        ) : <p className="font-medium text-sm text-red-500 text-center">خطا در دریافت اطلاعات!</p>
                    ) : <></>
                }
            </div >

            <Modal
                title="لغو سفارش"
                show={showCancelModal}
                closeHandler={() => setShowCancelModal(false)}
            >
                <form onSubmit={cancelHandler}>
                    <span className="block text-sm mb-4">دلیل لغو خود را بنویسید</span>
                    <textarea
                        value={cancelReason}
                        className="border w-full rounded-lg p-3 text-sm"
                        onChange={e => setCancelReason(e.target.value)}
                    />

                    <button type="submit" className="rounded-lg bg-primary-100 py-2 px-4 text-white text-sm mt-4 relative overflow-hidden">
                        ثبت

                        <CSSTransition in={cancelLoading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </form>
            </Modal>
        </>
    )
}

export default memo(Edit);